<!-- 摄像头列表 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="table-wrap">
        <el-form label-width="90px">
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item :label="$t('text.sxtbm')">
                <el-input
                  v-model="queryParams.alias"
                  clearable
                  :placeholder="$t('placeholder.sxtbm')"
                  @keyup.enter.native="handleQuery"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('text.sxtssdz')" label-width="110px">
                <el-input
                  v-model="queryParams.orgname"
                  clearable
                  :placeholder="$t('placeholder.sxtssdz')"
                  @keyup.enter.native="handleQuery"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('text.sxtxlh')" label-width="100px">
                <el-input
                  v-model="queryParams.gatewaysn"
                  clearable
                  :placeholder="$t('placeholder.sxtxlh')"
                  @keyup.enter.native="handleQuery"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-button
                type="primary"
                icon="el-icon-search"
                style="background:#175E77;border:none"
                @click="handleQuery"
              >{{ $t('button.cx') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-form>
          <VIDEO ref="video" :datas="list" />
        </el-form>
      </el-card>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        :page-sizes="pageSizes"
        :layout="layout"
        style="background:#1A4A6E"
        @pagination="handleQuery"
      />
    </div>
  </div>
</template>

<script>
import { QueryCameras } from '@/api/Device'
import VIDEO from './components/video.vue'

export default {
  components: {
    VIDEO
  },
  data () {
    return {
      queryParams: {},
      pageNum: 1,
      pageSize: 10,
      layout: 'prev, sizes, pager, next, jumper',
      pageSizes: [1, 2, 3, 4],
      total: 0,
      list: []
    }
  },
  created () {

  },
  mounted () {
    this.handleQuery()
  },
  beforeDestroy () {

  },
  methods: {
    getCameras () {
      QueryCameras({
        page: this.pageNum,
        perPage: this.pageSize,
        orderBy: "gatewaysn",
        whereCondition: JSON.stringify(this.queryParams)
      }).then(res => {
        this.list = res.data.queryResults
        this.total = res.data.totalCount
      }).then(() => {
        this.$refs.video.initCamera()
      })
    },
    handleQuery () {
      this.getCameras()
    },
  }
}
</script>
<style lang='stylus' scoped>
.table-wrap
 border none
 background-color #1D3666
.video
 margin-bottom 10px
.el-input
  >>>.el-input__inner
     border: 1px solid #1CC197
     background:#1D3666
     color: #fff
    >>>.el-input__prefix
       color: #fff
</style>

